import React from 'react';
import { Modal, IconButton, mergeStyleSets, getTheme, getId, FontSizes, FontWeights, Label } from '@fluentui/react';
import { UIConstants } from '../../shared/models/Constants';
import _ from 'lodash';
import { Asset } from '../../shared/models/UserAccess.model';

const theme = getTheme();
const iconButtonStyles = mergeStyleSets({
    root: {
        color: theme.palette.neutralPrimary,
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px'
    },
    rootHovered: {
        color: theme.palette.neutralDark
    }
});
const contentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch'
    },
    header: [
        theme.fonts.xLargePlus,
        {
            flex: '1 1 auto',
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            color: theme.palette.neutralPrimary,
            display: 'flex',
            fontSize: FontSizes.xLarge,
            alignItems: 'center',
            fontWeight: FontWeights.semibold,
            padding: '12px 12px 8px 24px'
        }
    ],
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        selectors: {
            p: {
                margin: '14px 0'
            },
            'p:first-child': {
                marginTop: 0
            },
            'p:last-child': {
                marginBottom: 0
            }
        }
    }
});

const classNames = mergeStyleSets({
    activityRoot: {
        marginTop: "20px"
    },
    nameText: {
        fontSize: 14,
        fontWeight: 600,

    }, actionText: {
        fontSize: 14,
    }, actionByText: {
        fontWeight: "bold",
        fontSize: FontSizes.medium,
        color: '#0064BF'
    },
    lblText: {
        fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
        // -webkit-font-smoothing: antialiased;
        fontSize: 14,
        fontWeight: 600,
        color: 'rgb(23, 23, 23)',
        boxSizing: 'border-box',
        boxShadow: 'none',
        margin: 0,
        display: 'block',
        padding: '5px 0px',
        overflowWrap: 'break-word',
    }
});

interface IRequestDetailsProps {
    isAdminScreen: boolean;
    onDismiss: Function;
    assets: Asset[];
    mode: string;
}
interface IAccessRequestDetailState {
    showModal: boolean,
    assetDetails: any,
}
export default class RequestViewAssetDetails extends React.Component<IRequestDetailsProps, IAccessRequestDetailState> {
    private _titleId: string = getId('title');
    constructor(props: any) {
        super(props);
        this.state = {
            showModal: true,
            assetDetails: [{ AssetName: ' Asset Name ', AssetId: ' Asset Id ', EntityName: ' Entity Name ' }]
        }
    }
    public render() {
        const { assetDetails, showModal } = this.state;
        const { assets, mode } = this.props
        return <React.Fragment>
            <Modal titleAriaId={this._titleId}
                isOpen={showModal} onDismiss={this._closeModal}
                isBlocking={false} containerClassName={contentStyles.container}>
                <div className={contentStyles.header}>
                    <span style={{ position: 'absolute', right: 10, paddingTop: 20, paddingBottom: 12, marginTop: 20 }} > <IconButton tabIndex={0} styles={iconButtonStyles} iconProps={{ iconName: 'Cancel' }}
                        ariaLabel="Close Access Details dialog" onClick={this._closeModal as any} /> </span>
                    <span style={{ position: 'absolute', left: 25, paddingTop: 20, paddingBottom: 12, marginTop: 20 }}   ><h2 role='heading' className={"h2"} style={{ paddingLeft: 0, fontSize: 20, margin: 0 }}>{UIConstants.MessageBoxTitle.AssetDetails}</h2>
                    </span>
                </div>
                <div role='presentation' className={contentStyles.body}>
                    <div style={{
                        height: '60vh',
                        width: '70vw',
                        overflow: 'auto',
                        display: 'block',
                        margin: '0 auto',
                        marginTop: 30
                    }}
                    >
                        <div id={'dv-asset-details'}>
                            <Label>Total number of Entities : {assets.length}</Label>
                            <table className="tb-asset-detail" style={{ lineHeight: 1, width:1000 }}>
                                <thead className="tb-asset-detail">
                                    {assetDetails.map(item => {
                                        return <div >
                                            {mode && <tr key={'tr-ast'}>
                                                <td key={'td-ast-name-key'} style={{ width: 500 }}><span className={classNames.nameText}>{item.AssetName}</span></td>
                                                <td key={'td-ast-ename-key'} style={{ width: 500 }}><span className={classNames.nameText}>{item.AssetId}</span></td>
                                            </tr>}
                                            {!mode && <tr key={'tr-ast'}>
                                                <td key={'td-ast-name-key'} style={{ width: 500 }}><span className={classNames.nameText}>{item.AssetName}</span></td>
                                                <td key={'td-ast-ename-key'} style={{ width: 500 }}><span className={classNames.nameText}>{item.EntityName}</span></td>
                                            </tr>}
                                        </div>
                                    })
                                    }
                                </thead>
                                <tbody>
                                    {assets.map(item => {
                                        return <div style={{ wordBreak: 'break-word' }}>
                                            {mode && <tr key={'tr-ast'}>
                                                <td key={'td-ast-name-key'} style={{ width: 500 }}><span className={classNames.actionText}>{item.EntityName}</span></td>
                                                <td key={'td-ast-ename-key'} style={{ width: 500 }}><span className={classNames.actionText}>{item.AssetId}</span></td>
                                            </tr>}
                                            {!mode && <tr key={'tr-ast'}>
                                                <td key={'td-ast-name-key'} style={{ width: 500 }}><span className={classNames.actionText}>{item.AssetName}</span></td>
                                                <td key={'td-ast-ename-key'} style={{ width: 500 }}><span className={classNames.actionText}>{item.EntityName}</span></td>
                                            </tr>}
                                        </div>
                                    })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    };
    private _closeModal = (): void => {
        this.setState({ showModal: false });
        this.props.onDismiss();
    };
}

